






































import { Prop, Component, Vue, Inject } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { RealworksCredentials } from '@/api/model/credentials'
import { RealworksCredentialsAPI } from '@/api/backend-client'

@Component
export default class CompanySettingsRealworksCredentialsEdit extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    @Prop({ required: true }) readonly credentialsId!: string
    credentials: RealworksCredentials = null
    editingCredentials: RealworksCredentials = null
    loading: boolean = false
    saving: boolean = false

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.credentials = await RealworksCredentialsAPI.get(this.credentialsId)
        this.editingCredentials = cloneDeep(this.credentials)
        this.loading = false
    }

    async save(): Promise<void> {
        this.saving = true
        this.credentials = await RealworksCredentialsAPI.update(this.credentialsId, this.editingCredentials)
        this.editingCredentials = cloneDeep(this.credentials)
        await this.reloadCompany()
        this.saving = false
        await this.$router.push({ name: 'company_settings_realworks_credentials_list' })
    }

    async cancel(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_realworks_credentials_list',
        })
    }
}
